import { MediaQuery } from "@outplayed/responsive";
import AdBoxWrapper from "components/common/Ads/AdBoxWrapper";
import FreestarAdSlot from "components/common/Ads/FreestarAdSlot";
import styles from "stylesheets/variables.module.scss";

const stickyTop = `calc(${styles.mastheadHeight} + 24px)`;

const ProSideColumn = () => {
  return (
    <div className="pro-page_side-column pw-side-column">
      <MediaQuery at="DESKTOP_LARGE" isClient renderNullOnFail>
        <AdBoxWrapper
          adStyles={{ display: "flex", alignItems: "center", justifyContent: "center" }}
          width={300}
          minAdHeight={250}
        >
          <FreestarAdSlot placementName="probuildstats-com_right_rail" slotId="probuildstats-com_right_rail" adSize="__300x250" />
        </AdBoxWrapper>
      </MediaQuery>
      <MediaQuery at="DESKTOP_LARGE" isClient renderNullOnFail>
        <AdBoxWrapper
          styles={{ position: "sticky", top: stickyTop }}
          adStyles={{ display: "flex", alignItems: "center", justifyContent: "center" }}
          width={300}
          minAdHeight={250}
        >
          <FreestarAdSlot
            placementName="probuildstats-com_med_rect_atf"
            slotId="probuildstats-com_med_rect_atf"
            adSize="__300x250"
          />
        </AdBoxWrapper>
      </MediaQuery>
    </div>
  );
};

export default ProSideColumn;
